module.exports = __webpack_public_path__ + "static/media/ma.bee9c054.svg";